<nav class="productDiscover__container">
  <div class="productDiscover__slider" #scrollable>
    <div class="productDiscover__item" *ngFor="let product of items; let i = index">
      <vc-catalog-snippet
        [index]="i"
        [likedItem]="likedItem"
        [product]="product"
        [seoContext]="seoContext"
        [eventToObserve]="eventClick"
      ></vc-catalog-snippet>
    </div>
    <ng-container *ngIf="isMdUp">
      <button class="mainControl mainControl--mainPrev leftRs" (click)="scrollToPrev(scrollable)">
        <vc-sprite-icons class="mainControl__icon mainControl__icon--left" name="arrow-head-left"></vc-sprite-icons>
      </button>
      <button class="mainControl mainControl--mainNext rightRs" (click)="scrollToNext(scrollable)">
        <vc-sprite-icons class="mainControl__icon mainControl__icon--right" name="arrow-head-right"></vc-sprite-icons>
      </button>
    </ng-container>
  </div>
</nav>
